import { getOrganizationId } from './scriptMarkupOrganizationData.js';

export const buildProductOffers = ({ url, currency, prices, host }) => {
  // Without a price an Offer is invalid (Google: "Either price or
  // priceSpecification.price should be specified"). Omit offers entirely.
  if (!Array.isArray(prices) || prices.length === 0) {
    return null;
  }

  const base = {
    ...(url ? { url } : {}),
    ...(currency ? { priceCurrency: currency } : {}),
    availability: 'https://schema.org/InStock',
    seller: { '@id': getOrganizationId(host) },
  };

  // prices is sorted ascending; aggregate across the product's SKUs/tiers.
  const low = prices[0];
  const high = prices[prices.length - 1];

  if (low === high) {
    return { '@type': 'Offer', price: String(low), ...base };
  }

  return {
    '@type': 'AggregateOffer',
    lowPrice: String(low),
    highPrice: String(high),
    offerCount: prices.length,
    ...base,
  };
};
